import { DeviceType, getDeviceTypeAsync, modelName, osName, osVersion } from "expo-device";
import Constants from "expo-constants";
import NetInfo from "@react-native-community/netinfo";

export interface DeviceInfo {
  deviceType: string;
  deviceModel: string;
  osName: string;
  osVersion: string;
  appVersion: string;
  connectionType: string;
  isConnected: boolean | null;
}

const deviceTypeMap: Record<DeviceType, string> = {
  [DeviceType.UNKNOWN]: "unknown",
  [DeviceType.PHONE]: "phone",
  [DeviceType.TABLET]: "tablet",
  [DeviceType.DESKTOP]: "desktop",
  [DeviceType.TV]: "tv",
};

const getDeviceInfo = async (): Promise<DeviceInfo> => {
  const [deviceType, netState] = await Promise.all([
    getDeviceTypeAsync(),
    NetInfo.fetch(),
  ]);

  return {
    deviceType: deviceTypeMap[deviceType] ?? "unknown",
    deviceModel: modelName ?? "unknown",
    osName: osName ?? "unknown",
    osVersion: osVersion ?? "unknown",
    appVersion: Constants.expoConfig?.version ?? "unknown",
    connectionType: netState.type,
    isConnected: netState.isConnected,
  };
};

export default getDeviceInfo;
